export class HisInformationSetting {
  constructor(
    public key: string,
    public name: string,
    public itemType: string,
    public objectType: string,
    public edit: boolean,
    public isFreeInput: boolean,
    public isReplace: boolean,
    public dataType: string,
    public isMultiSelect: boolean,
    public screenType: string,
    public isWarning: boolean,
    public reloadType: string,
    public setPlaceType: string,
    public explanation: string,
    public calculate: boolean,
  ) {
  }

  clone() {
    return new HisInformationSetting(
      this.key,
      this.name,
      this.itemType,
      this.objectType,
      this.edit,
      this.isFreeInput,
      this.isReplace,
      this.dataType,
      this.isMultiSelect,
      this.screenType,
      this.isWarning,
      this.reloadType,
      this.setPlaceType,
      this.explanation,
      this.calculate,
    );
  }

}
